import { useEffect } from "react";
import * as S from '../Elements/ElementStyles';
import { Icon } from '@fluentui/react/lib/Icon';
import React from "react";

const closeBtn =
{
    root:
    {
        fontSize: "14px",
        fontWeight: "600",
        position: "relative" as const,
        color: "#605e5c",
    },
}

const ModalElementsIATransfer = ({setModalShow, okModal, errorMessage, onClose}: {setModalShow: any, okModal: boolean, errorMessage?: string, onClose?: () => void}) =>
{
    const [height, setHeight] = React.useState('');

    useEffect(() =>
    {
        const toHeight = document?.querySelector('#root')?.scrollHeight + 'px';
        setHeight(toHeight);
    }, []);

    return(
        <React.Fragment>
            <S.HelperStyle />
            <S.ModalIAMainCont>
                <S.ModalToExitCont>
                    <S.IASavingPlanRemoveButton onClick={() => 
                    {
                        setModalShow(false);
                        if(onClose)
                        {
                            onClose();
                        }
                    }}>
                        <Icon iconName='Cancel' styles={closeBtn} />
                    </S.IASavingPlanRemoveButton>
                </S.ModalToExitCont>
                {okModal === true &&
                (
                    <React.Fragment>
                        <S.ModalContinue>
                            ¡Proceso de firma completado!
                        </S.ModalContinue>
                        <S.ModalNeedsCont>
                            <p>
                                Enhorabuena, has completado el proceso de reembolso de Elements IA.
                                Tendrás el reembolso en tu cuenta en aproximadamente 48 horas.
                            </p>
                        </S.ModalNeedsCont>
                    </React.Fragment>
                )}
                {okModal === false &&
                (
                    <React.Fragment>
                        <S.ModalContinue>
                            Ha habido un error al procesar la operación
                        </S.ModalContinue>
                        <S.ModalNeedsCont>
                            {errorMessage !== undefined && errorMessage !== "" &&
                            (
                                <React.Fragment>
                                    <p style={{cursor: 'default'}}>
                                        {errorMessage}
                                    </p>
                                </React.Fragment>
                            )}
                            <p style={{cursor: 'default'}}>
                                Por favor, ponte en contacto con <a href="mailto:info@ironia.tech">info@ironia.tech</a> indicando
                                de qué Plan de Ahorro se trata la cantidad de Elements IA que deseas reembolsar.
                            </p>
                        </S.ModalNeedsCont>
                    </React.Fragment>
                )}
                <S.ModalBtnCont>
                    {okModal ?
                    (
                        <S.ModalLinkBtn to={'/ElementsIA'}>
                            <S.ModalAcceptBtn>Aceptar</S.ModalAcceptBtn>
                        </S.ModalLinkBtn>
                    ) :
                    (
                        <S.ModalAcceptBtn onClick={() => 
                        {
                            setModalShow(false);
                            if(onClose)
                            {
                                onClose();
                            }
                        }}>
                            Aceptar
                        </S.ModalAcceptBtn>
                    )}
                </S.ModalBtnCont>
            </S.ModalIAMainCont>
            <S.ModalFocus className='modal' style={{height: height}} />
        </React.Fragment>
    );
};

export default ModalElementsIATransfer;